export default function () {
    return {
        KEYS: {
            MARK_AS_PARTICIPATED: 'MARK_AS_PARTICIPATED',
            MARK_AS_NOT_PARTICIPATED: 'MARK_AS_NOT_PARTICIPATED',
            ASSESSMENT_FINISHED_TEST_PASSED: 'ASSESSMENT_FINISHED_TEST_PASSED',
            ASSESSMENT_FINISHED_TEST_FAILED: 'ASSESSMENT_FINISHED_TEST_FAILED'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/schedule/bulkActions/index.js